<template>
	<section>
		<div class="d-flex flex-row align-items-center justify-content-between">
			<h3 class="mb-0">Additional Charges</h3>

			<div v-if="!isFinalized">
				<button class="btn btn-success" v-on:click="newAdditionalCharge">
					<i class="fa fa-plus"></i>
					Add Additional Charge
				</button>
			</div>
		</div>

		<div class="row mt-2" v-if="!hidePermitting">

			<div class="col-xl-12 col-lg-6 col-md-12">
				<field 
					label="Permit Required" 
					col-class="col-xl-4 col-lg-6 col-md-4" 
					v-model="$store.service.permit_needed" 
					:params="{type: 'boolean'}" 
					:invalid="$store.errorList.permit_needed"
					:readonly="isFinalized"
					v-on:change="permitRequiredChange">
				</field>
			</div>
			<div class="col-xl-12 col-lg-6 col-md-12">
				<field v-if="$store.service.permit_needed == 1" label="Permit Cost" 
					col-class="col-xl-4 col-lg-6 col-md-4" 
					v-model="$store.service.permit_cost" 
					:params="{type:'number',min:0, step:0.01}" 
					:invalid="$store.errorList.permit_notification_number"
					:readonly="isFinalized"
					v-on:change="permitCostChange">
				</field>
			</div>
		</div>
		
		<table-list
			record-name="Additional Charge Item"
			:fields="additionalChargesFields"
			:records="mutatedCharges"
			:has-edit="!isFinalized"
			:has-delete="!isFinalized"
			:hide-record-count="true"
			v-on:edit="editAdditionalCharge"
			v-on:delete="deleteObject($event,invoiceObjectResource)">
		</table-list>

		<modal-dialog
			:modal-visible="additionalChargeEditModal.visible"
			:title="additionalChargeEditModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveObject(additionalChargeEditModal,false,invoiceObjectResource)"
			v-on:closeModal="additionalChargeEditModal.visible = false">

			<field label="Description" 
				col-class="col-md-4" 
				v-model="additionalChargeEditModal.payload.description"
				:params="{type:'text',maxlength:110}">
			</field>

			<field label="Qty" 
				col-class="col-md-4" 
				:params="{type:'number',step:0.01}" 
				v-model="additionalChargeEditModal.payload.qty">
			</field>

			<field label="Unit Price" 
				col-class="col-md-4" 
				:params="{type:'number',step:0.01}" 
				v-model="additionalChargeEditModal.payload.price">
			</field>

			<field label="Markup" 
				col-class="col-md-4" 
				:params="{type:'number',step:0.01}" 
				v-model="additionalChargeEditModal.payload.markup">

				<span v-if="additionalChargeEditModal.payload.markup == 0" class="text-danger">Setting markup to 0 will result in the additional charge total not being applied (total = qty x price x markup). If you do not want to apply markup, set it to 1.</span>

			</field>

			<field label="Taxable" 
				col-class="col-md-4" 
				:params="{type:'boolean'}" 
				v-model="additionalChargeEditModal.payload.isTaxable">
			</field>

		</modal-dialog>
	</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"

export default {
	name: "InvoiceAdditionalChargesSection",
	components: {
		Field,
		TableList,
		ModalDialog
	},
	mixins: [InvoiceMixins],
	props: ["invoiceAdditionalCharges","invoiceId","invoiceObjectResource","isFinalized","hidePermitting"],
	data() {
		return {
			additionalChargesFields: [
				{label: "Description",key:"description"},
				{label: "Unit Price",key:"priceFormatted",align:"right"},
				{label: "Qty",key:"qty",align:"right"},
				{label: "Markup",key:"markup",align:"right"},
				{label: "Is Taxable",key:"isTaxable",type:"boolean",align:"center"},
				{label: "Total",key:"total",align:"right"}
			],
			additionalChargeEditModal: {
				visible: false,
				title: "Edit Additional Charge Item",
				payload: {
					isTaxable: 1,
					qty: 1,
					markup: 1
				},
				lineTotal: 0
			},
		}
	},
	computed: {
		mutatedCharges() {
			return this.invoiceAdditionalCharges.map(charge => {
				charge.priceFormatted = parseFloat(charge.price).toCurrency()
				if (!("qty" in charge) || charge.qty === null || charge.qty === false)
					charge.qty = 1

				let total = +charge.qty * +charge.price
				if ("markup" in charge)
					total = total * charge.markup

				charge.total = total.toCurrency(2)

				return charge
			})
		}
	},
	methods: {
		permitRequiredChange(permit_needed) {
			let vm = this

			let payload = {
				slug: this.$store.service.slug,
				permit_needed
			}

			this.postData("Service/save",payload)

			if (permit_needed) {

				if (+this.$store.service.permit_cost !== 0) {
					let additionalChargeObj = { //mocked modal
						payload: {
							type: "Additional",
							invoice_id: this.invoiceId,
							description: "Permit",
							price: +this.$store.service.permit_cost,
							isTaxable: 1,
							isPermitCharge: true,
							qty: 1
						},
						visible: false
					}
					this.saveObject(additionalChargeObj)
				}
			}
			else {
				//find permit
				let permitCharge = this.invoiceAdditionalCharges.find(charge => "isPermitCharge" in charge && charge.isPermitCharge)

				if (permitCharge) 
					this.deleteObject(permitCharge)
			}
		},
		permitCostChange(permit_cost) {
			let vm = this

			let payload = {
				slug: this.$store.service.slug,
				permit_cost
			}

			let permitCharge = this.invoiceAdditionalCharges.find(charge => "isPermitCharge" in charge && charge.isPermitCharge)

			let additionalChargeObj = {}

			if (permitCharge) {
				additionalChargeObj = { //mock modal
					payload: {
						type: "Additional",
						id: permitCharge.id,
						description: permitCharge.description,
						isTaxable: permitCharge.isTaxable,
						price: +permit_cost,
						qty: permitCharge.qty,
						invoice_id: this.invoiceId
					}
				}

				if ("markup" in permitCharge)
					additionalChargeObj.payload.markup = permitCharge.markup

				this.saveObject(additionalChargeObj)
			}
			else {
				//create
				let additionalChargeObj = { //mocked modal
					payload: {
						type: "Additional",
						invoice_id: this.invoiceId,
						description: "Permit",
						price: +permit_cost,
						isTaxable: 1,
						isPermitCharge: true,
						qty: 1
					},
					visible: false
				}
				this.saveObject(additionalChargeObj)
			}

			this.postData("Service/save",payload).then(response => {
				if (response.success)
					vm.$emit("permitCostChanged",permit_cost)
			})
		},
		editAdditionalCharge(record) {
			this.additionalChargeEditModal.visible = true
			this.additionalChargeEditModal.title = "Edit Additional Charge"
			this.additionalChargeEditModal.payload = JSON.parse(JSON.stringify(record))
		},
		newAdditionalCharge() {
			this.additionalChargeEditModal.visible = true
			this.additionalChargeEditModal.title = "Add Additional Charge"
			this.additionalChargeEditModal.payload = {
				invoice_id: this.invoiceId,
				type: "Additional",
				markup: 1,
				qty: 1,
				isTaxable: 1
			}
		}
	}
}
</script>